import { Row } from '@thd-olt-component-react/core-ui';
import React from 'react';

export const formatAddress = (addr) => {
  return (
    <div>
      <Row>
        {addr.firstName} {addr.lastName}
      </Row>
      <Row>
        {addr.addressLine1} {addr.addressLine2}
      </Row>
      <Row>
        {addr.city}, {addr.state} {addr.zip5}
      </Row>
    </div>
  );
};
